// ParametersProvider.tsx
import React, { ReactNode, useEffect, useState } from 'react';
import ParametersContext from './ParametersContext';
import { getLocalParameters } from 'src/helpers/AppCode';
import { DefaultParameters } from './DefaultParameters';
import LoadingSpinner from 'src/components/Common/UI/LoadingSpinner/LoadingSpinner';

interface ParametersProviderProps {
  children: ReactNode;
}

const ParametersProvider: React.FC<ParametersProviderProps> = ({ children }) => {
  const defaultParams = DefaultParameters();
  const [contextValue, setContextValue] = useState<LocalParameters>(defaultParams);
  const [isSettingParameters, setIsSettingParameters] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const parameters = await getLocalParameters();
        console.log("parameters", parameters)
        localStorage.setItem(`${process.env.REACT_APP_BASENAME}_localParameters`, JSON.stringify(parameters));
        setContextValue(parameters);
      }
      catch{
        console.error("Error on setting Parameters")
      }
      finally {
        setIsSettingParameters(false);
      }
    };

    fetchData();
  }, []);

  if(isSettingParameters) {
    return <LoadingSpinner />
  }

  return (
    <>
      {contextValue && 
        <ParametersContext.Provider value={contextValue}>
          {children}
        </ParametersContext.Provider>
      }
    </>
    
  );
};

export default ParametersProvider;
